import { skipToken } from '@reduxjs/toolkit/query/react';

import { useAppSelector } from 'store';
import { useGetPayerDetailsQuery } from 'store/api/referenceApi';

/* Payer specific feature flags */
export const PayerFeatures = {
    APREFERRAL: 'APREFERRAL',
    MEDBILLING: 'MEDBILLING',
    POLICY_MAN: 'POLICY_MAN',
    REQUESTS: 'REQUESTS',
} as const;
export type PayerFeature = (typeof PayerFeatures)[keyof typeof PayerFeatures];

export const usePayerFeatures = () => {
    const { payerId } = useAppSelector((state) => state.auth);
    const { data: payerDetails } = useGetPayerDetailsQuery(payerId ? { payerId } : skipToken);
    return payerDetails?.payerFeatures
        ? Object.fromEntries(payerDetails.payerFeatures.map((feature) => [feature, true]))
        : undefined;
};
